<template>
	<div class="right-sidebar-box">
		<div class="right-sidebar">
			<div class="search_box" @click.stop>
			  <input class="search_input" aria-label="Search for recommenders" v-model="search.nickname" type="text" :placeholder=placeholder />
			  <div class="el-icon-search-box" :class="icon_search ? '' : 'close_box'" @click="clear_search_input()">
					<i class="el-icon-search" v-if="icon_search"></i>
					<i class="el-icon-close" v-else></i>
				</div>
			</div>
			
			<div class="content_box_big">
				<div class="content_box" v-if="Loading">
					<Loading></Loading>
				</div>
				<div class="content_box" v-else>
					<div class="title">{{ $t('SearchUserArr.Who_to_follow') }}</div>
					<FanFollowList :Fan_Follow_List="list" :parent_type="parent_type" @modify_state="modify_state" @close_bulletFrame_fun="close_bulletFrame_fun"></FanFollowList>
				</div>
			</div>
			 
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import FanFollowList from '../components/public/FanFollowList.vue'
import { post_community_userfocus, post_community_searchuser } from '@/api/community.js'

export default {
	name: 'search-user',
	components: { FanFollowList },
	
	data() {
		return {
			parent_type: "search-user",
			placeholder: this.$t('SearchUserArr.more_users'),
			searchText: "",
			icon_search: true,
			search: {
				user_id: this.$store.state.userinfo.user_id,
				nickname: '',
				page: 1,
				per_page: 10,
			},
			list:[],
			Loading: false,
			loading_completed: false,
		}
	},
	
	// 监听
	watch: {
		"$store.state.userinfo": {
			handler: function (newValue, oldValue) {
				// this.search.user_id = this.$store.state.userinfo.user_id
				// this.get_data_list()
			},
			deep: true
		},
		"search.nickname": {
			handler: function (newValue, oldValue) {
				if(this.search.nickname && this.search.nickname != ''){
					this.icon_search = false
				}else{
					this.icon_search = true
				}
				this.search.page = 1
				this.get_data_list()
			},
			deep: true
		},
	},
	
	// beforeCreate() {
		
	// }
	
	created () {
	  
	},
  
	mounted() {
		this.get_data_list()
		// let that = this
		// setTimeout(()=>{
		// 	that.get_data_list()
		// },2000)
	},
  
	methods:{
		...mapActions(['updateFanFollowerStatus']), // 映射 Vuex 的 action
		//获取列表
		get_data_list(typeName){
			// if(!this.$store.state.userinfo.login_token){ return }
			// if(!this.search.user_id){ return }
			if(this.Loading){ return }
			if(typeName != "HiddeLoading"){
				this.Loading = true
				this.loading_completed = false
			}
			let obj = {
				// user_id: this.search.user_id, 
				nickname: this.search.nickname ? this.search.nickname : "TOZO", 
				// page: this.search.page,
				// per_page: this.search.per_page
			}
			console.log(obj)
			post_community_searchuser(obj)
		   .then((res) => {
				console.log(res)
				if(res.code == 0){
					this.list = res.data.data
				}else{
					this.exception_handling(res)
				}
				this.Loading = false
				this.loading_completed = true
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err)
		   })
		},
		
		//异常处理
		exception_handling(err){
			this.list = []
			this.Loading = false
			this.$errorMessage(err)
			// this.$message('err.data.message', 'error')
		},
		
		//取消/关注/删除
		modify_state(type){
			if(type == 'success'){
				this.get_data_list('HiddeLoading')
				this.updateFanFollowerStatus('success'); // 调用 action 传值
				console.log(this.$store.state.fan_follower_status)
				// this.$store.state.fan_follower_status++
			}
		},
		
		//清空输入框
		clear_search_input() {
			if(!this.icon_search){
				this.search.nickname = "";
			}
		},
		
		close_bulletFrame_fun(){
			this.$emit("close_bulletFrame_fun")
		}
  }
}
</script>

<style lang="less" scoped>
	*{
		box-sizing: border-box;
		font-family: Poppins, Poppins;
	}
	.right-sidebar-box {
		width: 100%;
		height: auto;
	}
	.right-sidebar{
		width: 100%;
		padding: 10px; 
		background-color: #ffffff;
		border-radius: 8px;
		padding: 20px 10px;
	}
	.search_box{
		width: 100%;
		padding-bottom: 10px;
		position: relative;
	}
	.search_input{
		width: 100%;
		height: 40px;
		border-radius: 20px;
		background: #FFFFFF;
		padding: 0px 40px 0px 13px;
		border: 1px solid #D9D9D9;
		font-family: Poppins, Poppins;
		font-weight: 400;
		font-size: 14px;
		color: #505050;
		line-height: 16px;
		text-align: left;
		font-style: normal;
		text-transform: none;
	}
	.search_input::placeholder {
	    color: #B3B3B3;
	}
	.el-icon-search-box{
		width: 40px;
		height: 40px;
		position: absolute;
		top: 0;
		right: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #B3B3B3;
	}
	.close_box{
		cursor: pointer;
	}
	.el-icon-search,
	.el-icon-close{
		font-size: 16px;
	}
	.content_box{
		margin-top: 16px;
		max-height: 100%;
		overflow: auto;
	}
	@media screen and (min-width: 1025px) {
		.content_box_big{
			max-height: calc(100vh - 200px);
			overflow: auto;
		}
	}
	@media screen and (max-width: 1024px) {
		.content_box_big{
			max-height: calc(100vh - 180px);
			overflow: auto;
		}
	}
</style>
